export class ReferralFilterModel  {
  referralStatusID: string;
  referringDrName: string;
  referralPatientName: string;
  providorDoctorName: string;
}
